// CAT Mock 6 — DILR section.
const di1Statement = `The table shows the production (in thousand units) of five factories, P–T, of a company in 2023 and 2024, and the percentage of each factory's production that was found to be defective in each year.`;
const di1Table = {
  columns: ["Factory", "Production 2023", "Production 2024", "Defective % 2023", "Defective % 2024"],
  rows: [
    ["P", "80", "100", "5", "4"],
    ["Q", "120", "132", "4", "5"],
    ["R", "60", "78", "10", "8"],
    ["S", "150", "135", "2", "2"],
    ["T", "90", "108", "6", "5"]
  ]
};

const di2Statement = `Six employees — A, B, C, D, E and F — attend a training programme on six consecutive days from Monday to Saturday, one employee per day. Each employee is from a different city: Delhi, Mumbai, Pune, Kochi, Jaipur and Goa.
• C attends on Wednesday.
• A attends on an earlier day than E, but not on the day immediately before E.
• D attends on the day immediately before or immediately after B.
• The employee from Goa attends on Saturday.
• F attends on the day immediately after the employee from Pune.
• B is from Kochi.
• The employee from Delhi attends on Monday.
• The employee from Jaipur attends on a later day than the employee from Mumbai.`;

const di3Statement = `The table shows the marks (out of 100) scored by five students, A–E, in Mathematics, Physics and Chemistry. Some entries are missing (shown as —). It is also known that:
• The average marks in Mathematics, Physics and Chemistry are 75, 72 and 74 respectively.
• B's total marks in the three subjects are 220.
• A's total marks are 10 more than D's total marks.`;
const di3Table = {
  columns: ["Student", "Mathematics", "Physics", "Chemistry"],
  rows: [
    ["A", "80", "—", "70"],
    ["B", "—", "65", "75"],
    ["C", "90", "85", "—"],
    ["D", "60", "—", "80"],
    ["E", "—", "70", "65"]
  ]
};

const di4Statement = `An airline connects four cities — K, L, M and N. The table shows the number of flights it operates each week from the city in the row to the city in the column. (For example, there are 12 flights a week from K to L.)`;
const di4Table = {
  columns: ["From \\ To", "K", "L", "M", "N"],
  rows: [
    ["K", "—", "12", "8", "5"],
    ["L", "10", "—", "6", "9"],
    ["M", "7", "4", "—", "11"],
    ["N", "6", "10", "3", "—"]
  ]
};

const catMock6Dilr = [
  {
    id: 25,
    type: "mcq",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "Which factory recorded the highest percentage growth in production from 2023 to 2024?",
    options: [
      "A. T",
      "B. R",
      "C. P",
      "D. Q"
    ],
    answer: "B"
  },
  {
    id: 26,
    type: "tita",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "For how many factories was the number of defective units produced in 2024 strictly greater than in 2023?",
    answer: "2"
  },
  {
    id: 27,
    type: "mcq",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "Which factory produced the fewest defective units in 2024?",
    options: [
      "A. P",
      "B. T",
      "C. Q",
      "D. S"
    ],
    answer: "D"
  },
  {
    id: 28,
    type: "tita",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "What was the total number of defective units produced by all five factories in 2023, in hundreds of units?",
    answer: "232"
  },
  {
    id: 29,
    type: "mcq",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "Suppose that from 2024 to 2025 each factory's production grows by the same percentage as it did from 2023 to 2024, and each factory's defective percentage stays at its 2024 level. Which factory will produce the most defective units in 2025?",
    options: [
      "A. Q",
      "B. T",
      "C. R",
      "D. P"
    ],
    answer: "C"
  },
  {
    id: 30,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Who attends the training on Thursday?",
    options: [
      "A. B",
      "B. A",
      "C. F",
      "D. D"
    ],
    answer: "B"
  },
  {
    id: 31,
    type: "tita",
    setId: "di2",
    statement: di2Statement,
    question: "Taking Monday as day 1, on which day number does the employee from Jaipur attend?",
    answer: "5"
  },
  {
    id: 32,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Who attends on the day immediately before the employee from Goa?",
    options: [
      "A. A",
      "B. C",
      "C. F",
      "D. D"
    ],
    answer: "C"
  },
  {
    id: 33,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Which of the following statements is true?",
    options: [
      "A. D is from Pune.",
      "B. C attends on the day immediately after the employee from Kochi.",
      "C. E attends on Friday.",
      "D. F is from Mumbai."
    ],
    answer: "B"
  },
  {
    id: 34,
    type: "tita",
    setId: "di2",
    statement: di2Statement,
    question: "How many employees attend on days strictly between the days on which D and A attend?",
    answer: "2"
  },
  {
    id: 35,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Who is from Mumbai?",
    options: [
      "A. A",
      "B. F",
      "C. E",
      "D. C"
    ],
    answer: "D"
  },
  {
    id: 36,
    type: "tita",
    setId: "di3",
    statement: di3Statement,
    table: di3Table,
    question: "What are C's marks in Chemistry?",
    answer: "80"
  },
  {
    id: 37,
    type: "mcq",
    setId: "di3",
    statement: di3Statement,
    table: di3Table,
    question: "Which student has the highest total marks in the three subjects?",
    options: [
      "A. Student B",
      "B. Student A",
      "C. Student D",
      "D. Student C"
    ],
    answer: "D"
  },
  {
    id: 38,
    type: "tita",
    setId: "di3",
    statement: di3Statement,
    table: di3Table,
    question: "What are E's marks in Mathematics?",
    answer: "65"
  },
  {
    id: 39,
    type: "mcq",
    setId: "di3",
    statement: di3Statement,
    table: di3Table,
    question: "How many students scored at least 70 marks in each of the three subjects?",
    options: [
      "A. 1",
      "B. 3",
      "C. 2",
      "D. 4"
    ],
    answer: "C"
  },
  {
    id: 40,
    type: "mcq",
    setId: "di3",
    statement: di3Statement,
    table: di3Table,
    question: "The students are ranked by total marks, and any tie is broken in favour of the student with higher marks in Chemistry. Who is ranked second?",
    options: [
      "A. Student B",
      "B. Student A",
      "C. Student D",
      "D. Student E"
    ],
    answer: "A"
  },
  {
    id: 41,
    type: "tita",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "How many flights depart from city L each week?",
    answer: "25"
  },
  {
    id: 42,
    type: "mcq",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "Which city receives the largest number of arriving flights each week?",
    options: [
      "A. K",
      "B. L",
      "C. M",
      "D. N"
    ],
    answer: "B"
  },
  {
    id: 43,
    type: "tita",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "For how many of the four cities is the number of arriving flights each week greater than the number of departing flights?",
    answer: "2"
  },
  {
    id: 44,
    type: "mcq",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "Between which pair of cities is the total number of flights per week, counting both directions, the largest?",
    options: [
      "A. L and N",
      "B. K and M",
      "C. K and L",
      "D. M and N"
    ],
    answer: "C"
  },
  {
    id: 45,
    type: "tita",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "Every flight has 180 seats. If every flight departing from city M is 80% full, how many passengers depart from M each week?",
    answer: "3168"
  },
  {
    id: 46,
    type: "mcq",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "The airline decides that, for every pair of cities, the number of flights in each direction will be reduced to the smaller of the two current figures for that pair. How many flights per week will be cut in total?",
    options: [
      "A. 12",
      "B. 14",
      "C. 17",
      "D. 15"
    ],
    answer: "D"
  }
];

export default catMock6Dilr;
